import Image from "next/image";
import Link from "next/link";
import React from "react";
import themes from "../../themes/themes";
import Remote from "../LoaderRemote";
import { useTranslation } from "../../context/TranslationContext";
const BlogItem = ({ data }) => {
  const { blogItemReadBtn } = useTranslation();
  return (
    <div className="blog_post flex md:flex-nowrap flex-wrap md:rounded-l-xl rounded-t-xl overflow-hidden mb-8">
      {data.resim && (
        <Link href={data.url}>
          <a
            title={data.title}
            className="shrink-0 md:w-80 w-full  h-80 relative "
          >
            <Image
              loader={Remote}
              src={data.resim}
              layout="fill"
              objectFit="cover"
              objectPosition={"center"}
              alt={data.title}
              sizes="(max-width: 768px) 60vw,
              (max-width: 1200px) 25vw,
              25vw"
            />
          </a>
        </Link>
      )}
      <div className="flex-1 flex flex-col p-4 gap-y-3 drop-shadow-xl md:rounded-r-xl  border-2">
        <span>{data.date}</span>
        <Link href={data.url}>
          <a title={data.title} className="d-block">
            <strong className="text-2xl">{data.baslik}</strong>
          </a>
        </Link>
        <p className="opacity-60 text-base">{data.kisa_icerik}</p>
        <Link href={data.url}>
          <a
            title={data.title}
            className="relative mt-auto inline-flex items-center justify-start w-48 py-3 pl-4 pr-12 overflow-hidden font-semibold text-[#000000] transition-all duration-250 ease-in-out rounded hover:pl-10 hover:pr-6 bg-brand-gray-5 group"
          >
            <span
              className={`absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out ${themes.blogBg} group-hover:h-full`}
            ></span>
            <span className="absolute right-0 pr-4 duration-250 ease-out group-hover:translate-x-12">
              <svg
                className={`w-5 h-5 ${themes.textBlog}`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span className="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-250">
              <svg
                className="w-5 h-5 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span className="relative w-full text-left transition-colors duration-250 ease-in-out group-hover:text-white">
              {blogItemReadBtn}
            </span>
          </a>
        </Link>
      </div>
    </div>
  );
};

export default BlogItem;
